import { useCacheSlice } from "../hooks";

export type Task = {
  taskCode: string;
  task: string;
  taskDescription: string;
  taskGroup: string;
};

export function useTasksCache() {
  const { data, isLoading } = useCacheSlice("tasks");
  const tasks = data as Task[];
  return { tasks, isLoading };
}
